export default __webpack_public_path__ + "static/media/student-enter-answer-fitb.b4c3d4ab.gif";